import prepareRule from "./_prepare-rule";

const packNotEmpty = (field, error) =>
	error != null // if not empty
		? { [field]: error } // pack to object with key equal field
		: null; // otherwise return null

const createFieldValidator = ([field, fieldRule]) => {
	const fieldValidator = prepareRule(fieldRule);
	return form => packNotEmpty(field, fieldValidator(form[field], form, field));
};

const validationReducer = form => (validationState, validator) => {
	const fieldError = validator(form);

	// eslint-disable-next-line no-param-reassign
	Object.assign(validationState.errors, fieldError);

	// eslint-disable-next-line no-param-reassign
	validationState.isValid = validationState.isValid && fieldError == null;

	return validationState;
};

/**
 * Creates `FormValidator` from array of field-validators.
 *
 * @typedef {import("./types").FieldValidator} FieldValidator
 * @typedef {import("./types").FormValidator} FormValidator
 * @type {(...validators: FieldValidator[]) => FormValidator}
 */
export const validateFormWith = validators => form =>
	validators.reduce(
		validationReducer(form), // applying all validators and merging their results
		{ isValid: true, errors: {} }, // initial State
	);

/**
 * Creates `FormValidator` from Validation Schema
 *
 * @typedef {import("./types").ValidationSchema} ValidationSchema
 * @typedef {import("./types").FormValidator} FormValidator
 * @type {(validationSchema: ValidationSchema) => FormValidator}
 */
const creteFormValidator = validationSchema =>
	validateFormWith(
		// creating an Array of form validators
		Object.entries(validationSchema).map(createFieldValidator),
	);

export default creteFormValidator;
